import { EXTRA_DATA, FR_CONTRACT_TYPE, PAY_STATUS_LIST } from "constants/haulpay-broker";

export const NEW_STATUS_LIST = [
  ...EXTRA_DATA,
  ...PAY_STATUS_LIST.map((item) => ({
    id: item.id + EXTRA_DATA.length,
    label: item.label,
    value: item.value
  }))
];

export const NEW_FUNDING_REQUEST_TYPE = [
  ...EXTRA_DATA,
  ...FR_CONTRACT_TYPE.map((item) => ({
    id: item.id + EXTRA_DATA.length,
    label: item.label,
    value: item.value
  }))
];
